import {
  ErrorType,
  type IKontaktorsak,
  KanalType,
  KundgruppType,
} from "@/composables/KundserviceAppApiClient";
import type { Option } from "@/types/form";
import { DEFAULT_API_ERROR_MESSAGE } from "@/common/constants";

export function mapPuzzelQueryStringToKanalType(
  value?: string | null,
): KanalType | null {
  switch (value?.toLowerCase()) {
    case "voice":
      return KanalType.Telefon;
    case "chat":
      return KanalType.Chat;
    case "email":
      return KanalType.Epost;
    default:
      return null;
  }
}

export function mapPuzzelQueryStringToKundgruppType(
  value?: string | null,
): KundgruppType | null {
  switch (value?.toLowerCase()) {
    case "arbetare":
      return KundgruppType.Arbetare;
    case "tjänsteman":
    case "tjansteman":
      return KundgruppType.Tjansteman;
    case "arbetsgivare":
      return KundgruppType.Arbetsgivare;
    case "arbetsgivarförbund":
    case "arbetsgivarforbund":
      return KundgruppType.Arbetsgivarforbund;
    case "partsbolag":
      return KundgruppType.Partsbolag;
    default:
      return null;
  }
}

export function kontaktorsakerToOptions(
  kontaktorsaker: IKontaktorsak[],
): Option[] {
  return kontaktorsaker.map((k) => ({
    id: k.id,
    label: k.namn,
  }));
}

export function errorTypeToMessage(error: ErrorType | null): string {
  switch (error) {
    case ErrorType.AgentNotFound:
      return "Du saknar ett giltigt konto i Freshdesk.";
    case ErrorType.EmailConflict:
      return "E-postadressen är redan registrerad på en annan kund.";
    case ErrorType.DummyContact:
      return "E-postadressen används av dummy-kontakten och kan inte användas.";
    case ErrorType.ForbiddenFromCreatingNote:
      return "Du saknar korrekt behörighet för att kommentera ett ärende. Kontakta IT-drift.";
    case ErrorType.ArendeAlreadyClosed:
      return "Ärendet är redan stängt.";
    case ErrorType.ArendeNotFound:
      return "Det aktuella ärendet hittas inte.";
    case ErrorType.PhoneNumberConflict:
      return "Telefonnumret är redan registrerat på en annan kund";
    case ErrorType.Unknown:
    case ErrorType.InvalidContact:
    default:
      return DEFAULT_API_ERROR_MESSAGE;
  }
}
